






























import Vue from "vue";
import {
  ResponseListItem,
  PuzzleListItem,
  VueConstructor,
  ResponseModalI,
  Game
} from "vue/types/vue";
import { PuzzleService } from "../../services/puzzleservice";
import { PuzzleData } from "../../services/vo";
import PuzzleResponseItem from "@/components/User/PuzzleResponseItem.vue";
import ResponseModal from "@/components/User/ResponseModal.vue";
import { ResponseType } from "axios";

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      responseModal: ResponseModalI;
    };
  }
>).extend({
  name: "Responses",
  components: {
    PuzzleResponseItem,
    ResponseModal
  },
  data() {
    return {
      puzzleid: this.$route.params.puzzleid,
      responses: new Array<ResponseListItem>(),
      showModal: false,
      puzzle: new Array<PuzzleData>(),
      loading: false,
      noResponsesMessage: "Inga inskickade lösningar."
    };
  },
  async created() {
    this.responses = new Array<ResponseListItem>();
    this.puzzle = new Array<PuzzleData>();
    await this.getResponses();
  },
  methods: {
    getResponses: async function (): Promise<void> {
      this.loading = true;

      try {
        const responses = await PuzzleService.getPuzzleResponses(this.puzzleid);
        const puz = await PuzzleService.getPuzzleById(this.puzzleid);

        this.puzzle = puz;
        this.$refs.responseModal.setPuzzle(this.puzzle);
        this.responses = responses;
      } catch (error: any) {
        console.log(error);
        if (error.response.status === 403) {
          this.noResponsesMessage = "Du har inte behörighet att se inskickade lösningar för detta kryss.";
        }
        else {
          this.noResponsesMessage = "Inga inskickade lösningar."
        }
      } finally {
        this.loading = false;
      }
    },
    openResponseModal: function (response: ResponseListItem): void {
      this.showModal = true;
      this.$refs.responseModal.setResponse(response);
    },

    closeModal: function (): void {
      this.showModal = false;
    }
  }
});
